import React from "react";
import { Download } from "lucide-react";
import { FileViewerModal } from "./FileViewerModal";

import {
  getFileIcon,
  getFileType,
  getMimeType,
  getFileColor,
} from "../utils/fileUtils";

export function FilePreview({ files, backendUrl }) {
  const [selectedFile, setSelectedFile] = React.useState(null);

  if (!files?.length) return null;

  const handleDownload = (e, file) => {
    e.stopPropagation();
    const link = document.createElement("a");
    link.href = file;
    link.download = file.split("/").pop() || "file";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileClick = (file) => {
    const fileName = file.url.split("/").pop() || "file";
    setSelectedFile({
      url: file,
      name: fileName,
      type: getMimeType(fileName),
    });
  };

  return (
    <>
      <div className="mt-3">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {files.map((file, index) => {
            const fileName = file.url.split("/").pop() || "file";
            const fileType = getFileType(fileName);

            return (
              <div
                key={index}
                onClick={() => handleFileClick(file)}
                className={`group relative aspect-[4/3] overflow-hidden rounded-xl border border-gray-100 hover:border-blue-300 transition-all duration-200 cursor-pointer ${getFileColor(
                  fileType
                )}`}
              >
                {fileType === "image" ? (
                  <img
                    src={`${backendUrl}${file.url}`}
                    alt={fileName}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <div className="w-16 h-16 rounded-xl bg-gray-100 flex items-center justify-center">
                      {getFileIcon(fileType)}
                    </div>
                  </div>
                )}

                {/* Overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        {getFileIcon(fileType)}
                        <span className="text-sm text-white font-medium truncate max-w-[150px]">
                          {fileName}
                        </span>
                      </div>
                      <button
                        onClick={(e) => handleDownload(e, file)}
                        className="text-white hover:text-blue-200 transition-colors"
                      >
                        <Download size={16} />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Quick view button */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <div className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg transform translate-y-2 group-hover:translate-y-0 transition-transform duration-200">
                    <span className="text-sm font-medium text-gray-700">
                      Vista rápida
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {selectedFile && (
        <FileViewerModal
          file={selectedFile}
          onClose={() => setSelectedFile(null)}
          backendUrl={backendUrl}
        />
      )}
    </>
  );
}
